
import {defineComponent} from 'vue'
import moment from 'moment'
import { ReportFilter } from '@/model/models'
import Multiselect from "@vueform/multiselect"

export default defineComponent( {
  name: 'ReportTimeRangeFilter',
  components: {
    Multiselect
  },
  props: {
    filter: ReportFilter
  },
  data() {
    return {
      selected: 4,
      options: [
        { value: 0, label: 'Today' },
        { value: 1, label: 'Yesterday' },
        { value: 2, label: 'This week' },
        { value: 3, label: 'Last week' },
        { value: 4, label: 'Last 7 days' },
        { value: 5, label: 'Last 14 days' },
        { value: 6, label: 'Last 21 days' },
        { value: 7, label: 'Last 28 days' },
        { value: 8, label: 'This month' },
        { value: 9, label: 'Last month' },
        { value: 10, label: 'Last 3 months' },
        { value: 11, label: 'Last 6 months' },
        { value: 12, label: 'This year' },
        { value: 13, label: 'Last year' }
      ]
    }
  },
  emits: [
    'filter-changed'
  ],
  created() {
    this.onSelect()
  },
  methods: {
    onSelect() {
      const range = this.timeRange
      this.$emit('filter-changed', { name:  this.filter?.name, value: String(range.from) + ',' + String(range.to)})
    }
  },
  computed: {
    timeRange() {
      var fromDate = moment(new Date()).startOf('day')
      var toDate = moment(new Date()).endOf('day')

      switch (this.selected) {
        case 1:
          fromDate = moment(fromDate).subtract(1, 'day')
          toDate = moment(toDate).subtract(1, 'day')
          break
        case 2:
          fromDate = moment(fromDate).startOf('week').add(1, 'day')
          break
        case 3:
          fromDate = moment(fromDate).startOf('week').add(1, 'day').subtract(1, 'week')
          toDate = moment(fromDate).add(1, 'week').subtract(1, 'second')
          break
        case 4:
          fromDate = moment(fromDate).subtract(6, 'day')
          break
        case 5:
          fromDate = moment(fromDate).subtract(13, 'day')
          break
        case 6:
          fromDate = moment(fromDate).subtract(20, 'day')
          break
        case 7:
          fromDate = moment(fromDate).subtract(27, 'day')
          break
        case 8:
          fromDate = moment(fromDate).startOf('month')
          break
        case 9:
          fromDate = moment(fromDate).startOf('month').subtract(1, 'month')
          toDate = moment(toDate).endOf('month').subtract(1, 'month')
          break
        case 10:
          fromDate = moment(fromDate).startOf('month').subtract(3, 'month')
          break
        case 11:
          fromDate = moment(fromDate).startOf('month').subtract(6, 'month')
          break
        case 12:
          fromDate = moment(fromDate).startOf('year')
          break
        case 13:
          fromDate = moment(fromDate).startOf('year').subtract(1, 'year')
          toDate = moment(fromDate).endOf('year').subtract(1, 'second')
          break
      }

      return { from: (fromDate.toDate().getTime() / 1000) | 0, to: (toDate.toDate().getTime() / 1000) | 0 }
    }
  }
})
